import './App.css';
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { auth, db } from './firebase';
import { collection, onSnapshot, query,doc, getDoc } from 'firebase/firestore';
import moment from 'moment';

import Login from './auth/Login';
import Register from './auth/Register';
import Header from './panel/Header';
import Forgetpass from './auth/Forgetpass';

import Dashboard from './components/Dashboard';
import Allrooms from './components/dashboard/Allrooms';
import Reserveroom from './components/booking/Reserveroom';
import Livebookingrooms from './components/dashboard/Livebookingrooms';
import Availablerooms from './components/dashboard/Availablerroms';
import Cleaningrooms from './components/dashboard/Cleaningrooms';
import Livebookings from './components/booking/Livebookings';
import Viewdetails from './components/booking/Viewdetails';
import Approvals from './components/Approvals';

import Websiterooms from './components/ota/Websiterooms';
import Websitegallery from './components/ota/Websitegallery';
import Advancebooking from './components/booking/Advancebooking';
import Viewadvance from './components/booking/Viewadvance';
import Advancedetails from './components/booking/Advancedetails';

import Onlinebookings from './components/ota/Onlinebookings';
import Websitereservation from './components/booking/Websitereservation';
import Futurereservation from './components/booking/Futurereservation';

import Checkouthistory from './components/booking/Checkouthistory';
import Roomcleanings from './components/booking/Roomcleaning';
import Roomcleaned from './components/booking/Roomcleaned';
import Damagenotes from './components/booking/Damagenotes';
import Pendingbookings from './components/ota/Pendingbookings';
import Hotelinvoice from './components/booking/Hotelinvoice';
import Checkoutalert from './components/booking/Checkoutalert';

import Dailyreport from './components/Dailyreport';
import Bookingreport from './components/Bookingreport';
import Roomtypewiseonline from './components/Roomtypewise';
import Bookingtypes from './components/Bookingtypes';
import Paymentmode from './components/Paymentmode';
import Subpaymode from './components/Subpaymode';
import Roomdetails from './components/Roomdetails';
import Companydetails from './components/Companydetails';
import Customerwise from './components/Customerwise';
import Advanceprint from './components/booking/Advanceprint';
import Pendingpayments from './components/booking/Pendingpayments';
import Planexpired from './components/Planexpired';
import Dcrreport from './components/booking/Dcrreport';
import Backdatereport from './components/Backdatereport';
import Customers from './components/booking/Customers';
import Mobilebooking from './components/booking/Mobilebooking';
import Planwisebookings from './components/booking/Planwisebookings';

function App() {
  const [user, setUser] = useState();

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      setUser(user);
    });
  });

  useEffect(() => {
    // Set a timer for 5 minutes (300,000 ms)
    const timer = setTimeout(() => {
        callFun();
    }, 900000);

    return () => clearTimeout(timer);
}, []);



const callFun = () => {
    const q111 = query(collection(db, 'plans'))
    onSnapshot(q111, (querySnapshot) => {
        if (querySnapshot.size > 0) {
            let today = moment().format('YYYY-MM-DD');
            let enddate = querySnapshot.docs[0].data().enddate;
            if (today > enddate) {
                window.location.href = "/plan-expired"
            }
        }
    });
}





  return (
    <div className="wrapper">
      {
        !user ?
          <Router>
            <Routes>
              <Route path='/' element={<Login />} />
              <Route path='/login' element={<Login />} />
              <Route path='/Register' element={<Register />} />
              <Route path='/forgot-password' element={<Forgetpass />} />
            </Routes>
          </Router>
          :
          <>
            <Header />
            <Router>
              <Routes>
                <Route path='/' element={<Dashboard />} />
                <Route path='/planwise-bookings' element={<Planwisebookings />} />
                <Route path='/mobileno-wise-bookings' element={<Mobilebooking />} />
                <Route path='/customers' element={<Customers />} />
                <Route path='/home' element={<Dashboard />} />
                <Route path='/reserve-room' element={<Reserveroom />} />
                <Route path='/all-rooms' element={<Allrooms />} />
                <Route path='/live-booking-rooms' element={<Livebookingrooms />} />
                <Route path='/available-rooms' element={<Availablerooms />} />
                <Route path='/cleaning-rooms' element={<Cleaningrooms />} />
                <Route path='/live-bookings' element={<Livebookings />} />
                <Route path='/view-details/:documentId' element={<Viewdetails />} />
                <Route path='/approval-requests' element={<Approvals />} />

                <Route path='/future-paid-bookings' element={<Advancebooking />} />
                <Route path='/view-future-bookings' element={<Viewadvance />} />
                <Route path='/view-futuredetails/:documentId' element={<Advancedetails />} />

                <Route path='/website-rooms' element={<Websiterooms />} />
                <Route path='/website-gallery' element={<Websitegallery />} />
                <Route path='/online-bookings/:type' element={<Onlinebookings />} />
                <Route path='/website-reservation/:webid' element={<Websitereservation />} />
                <Route path='/futurebookings-reservation/:webid' element={<Futurereservation />} />
                <Route path='/checkout-history' element={<Checkouthistory />} />
                <Route path='/room-cleaning' element={<Roomcleanings />} />
                <Route path='/room-cleaned' element={<Roomcleaned />} />
                <Route path='/damage-notes' element={<Damagenotes />} />
                <Route path='/checkout-alert' element={<Checkoutalert />} />

                <Route path='/pending-bookings' element={<Pendingbookings />} />
                <Route path='/print-invoice/:documentId' element={<Hotelinvoice />} />
                <Route path='/print-advance/:documentId' element={<Advanceprint />} />

                <Route path='/daily-report' element={<Dailyreport />} />
                <Route path='/booking-report' element={<Bookingreport />} />
                <Route path='/room-type-wise-online-bookings' element={<Roomtypewiseonline />} />

                <Route path='/booking-types' element={<Bookingtypes />} />
                <Route path='/payment-modes' element={<Paymentmode />} />
                <Route path='/owner-credit' element={<Subpaymode />} />
                <Route path='/room-details' element={<Roomdetails />} />
                <Route path='/company-details' element={<Companydetails />} />
                <Route path='/customerwise-report' element={<Customerwise />} />

                <Route path='/pending-payments' element={<Pendingpayments />} />
                <Route path='/plan-expired' element={<Planexpired />} />
                <Route path='/dcr-report' element={<Dcrreport />} />
                <Route path='/back-date-report' element={<Backdatereport />} />


              </Routes>
            </Router>
            {/* <Footer /> */}
          </>
      }

    </div >
  );
}

export default App;
